/**
 * Created By Elia Rohana on 12/18/18
 */

/**
 * generate the needed script for the script task of each sub process based on the condition
 */
export class ScriptTaskGenerator {

    public generateScript(script: string, condition: string, counterName: string): string {
        const scriptAsArray = script.split('\n');
        if (scriptAsArray.length > 1) {
            scriptAsArray.splice(scriptAsArray.length - 1, 1);
        }
        if (scriptAsArray.length == 1) {
            scriptAsArray.push(this.initScript(counterName));
        }
        const newScript = [scriptAsArray.join('\n')];
        newScript.push(`if(${condition}){`);
        newScript.push(`${counterName}++;`);
        newScript.push('}');
        newScript.push(counterName);

        return newScript.join('\n');
    }

    private initScript(counterName: string) {
        return `${counterName} = 0`;
    }


}
